<template>
    <div class='main'>
        <div class="StackpaenlHor">
            <button class="LightButton " @click="addModel()">加载模型</button>
            <button class="LightButton " @click="addModel1()">加载模型1</button>
            <button class="LightButton " @click="getComponentProperty()">数据</button>
            <button class="LightButton " id="btnShowRingScan" @click="showRingScan()">扫描</button>
        </div>
        <div style="width:100%;height:100%;">
            <div class="LightModel">
                <div id="domId" class="Content">

                </div>
                <div class="Mask">

                </div>
            </div>
            <div id="DataId">
            </div>
        </div>
    </div>
</template>


<style scoped>
.Mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 95%;
    background: linear-gradient(45deg,
            rgba(97, 105, 105, 0.8),
            /* 红色通道半透明 */
            rgba(44, 75, 178, 0.6)
            /* 蓝色通道半透明 */
        );
    mix-blend-mode: overlay;
    /* 关键混合模式 */
    pointer-events: none;
    z-index: 1;
}

.LightModel {
    position: static;
    right: 0px;
    top: 50px;
    bottom: 0px;
    color: #ccc;
    background: gray;
    width: 100%;
    height: 98%;
}

.Content {
    position: relative;
    width: 100%;
    height: 98%;
    object-fit: cover;
    /* 确保内容在蒙版上层 */
}

.DataModel {
    position: static;
    right: 0px;
    top: 10px;
    bottom: 0px;
    color: #ccc;
    background: rgb(162, 125, 125);
    height: 25%;
    visibility: hidden;
}

.Copoment-dialog {
    position: fixed;
    left: auto;
    /* 取消左定位，因为我们要自定义位置 */
    top: -20px;
    right: 10px;
}

.el-row {
    margin-bottom: 2px;

}

.el-col {
    border-radius: 4px;

}

.bg-purple-dark {
    height: 45px;
    background: #99a9bf;
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 20px;
    border: 2px solid black;
    padding: 5px;
}

.bg-purple-light {
    height: 45px;
    background: #e5e9f2;
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 18px;
    border: 2px solid black;
    padding: 5px;
}
</style>
<script type="text/javascript">
import { Alert } from 'element-ui';
import * as echarts from 'echarts';
let app;
let OSGBviewToken;
let modelid = 100031085563;//这个是社区中心和服务中心的模型
let modelid1 = 100031084638;//这个是小区样板的模型
let ModelviewToken;
let ModelviewToken1;
let viewer3D;
let model3D;
let model3D1;
let model3D2;
let isRingScanEffectAdded = false;
let ringScanEffect
export default {
    data: function () {
        return {

        };
    },
    props: ["id"],
    methods: {
        fluseModel() {
            let viewToken = this.OSGBviewToken;
            let isRingScanEffectAdded = false;
            let ringScanEffect
            // 初始化显示组件
            let options = new BimfaceSDKLoaderConfig();
            options.viewToken = viewToken;
            BimfaceSDKLoader.load(options, successCallback, failureCallback);
            const that = this;
            function successCallback(viewMetaData) {
                if (viewMetaData.viewType == "3DView") {
                    // ======== 判断是否为3D模型 ========        
                    // 获取DOM元素
                    let dom4Show = document.getElementById('domId');
                    dom4Show.innerHTML = '';
                    let webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
                    webAppConfig.domElement = dom4Show;
                    // 设置全局单位
                    webAppConfig.globalUnit = Glodon.Bimface.Common.Units.LengthUnits.Millimeter;
                    webAppConfig.enableToggleContextMenuDisplay = false;
                    //是否开启鼠标悬停效果
                    //webAppConfig.enableHover = true;
                    //是否显示轮廓线
                    webAppConfig.enableBorderLine = false;
                    //设置曝光度
                    webAppConfig.exposure = 0.4;
                    //是否启用环境光照
                    //webAppConfig.enableIBLBackground = true;
                    //是否选择环境贴图（和背景色设置其中一个即可）
                    //webAppConfig.loadIBLScene={IBLSceneOption: "HarborSunRise", withBackground: true}
                    //是否设置默认背景色
                    webAppConfig.backgroundColor = [{
                        color: new Glodon.Web.Graphics.Color(25, 28, 33, 1),
                        stop: "0%"
                    },
                    {
                        color: new Glodon.Web.Graphics.Color(37, 76, 71, 1),
                        stop: "50%"
                    }
                    ];

                    // 创建WebApplication
                    app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
                    // 添加待显示的模型
                    app.addView(viewToken);
                    // 从WebApplication获取viewer3D对象
                    viewer3D = app.getViewer();

                    // 监听添加view完成的事件
                    viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, function () {
                        //自适应屏幕大小
                        window.onresize = function () {
                            viewer3D.resize(document.documentElement.clientWidth, document.documentElement
                                .clientHeight - 40);
                        }
                        // 调用viewer3D对象的Method，可以继续扩展功能
                        // 渲染3D模型
                        model3D = viewer3D.getModel();
                        viewer3D.render();
                        //viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.MouseClicked, getData);
                        //model3D1 = viewer3D.getModel(100031085520);
                        //model3D2 = viewer3D.getModel(100031085501);
                    });
                    viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ModelAdded, function (data) {
                        //从viewer3D对象中获取模型对象model3D
                        //model3D1 = viewer3D.getModel(100031084638);
                        if(data==modelid1)
                        {
                            model3D1 = viewer3D.getModel(modelid1);
                            // 平移模型
                            model3D1.setModelTranslation({ x: -190000, y: 340000, z: 495000 });
                        }
                        else if(data==modelid)
                        {
                            model3D1 = viewer3D.getModel(modelid);
                            // 平移模型
                            model3D1.setModelTranslation({ x: -65800, y: -90000, z: 418000 });
                        }
                    });
                }
            }

            function failureCallback(error) {
                console.log(error);
            }

        },
        addModel() {
            viewer3D.loadModel({
                viewToken: this.ModelviewToken1,
                modelId: modelid1

            });
            viewer3D.loadModel({
                // 待加载模型的浏览凭证
                viewToken: this.ModelviewToken,
                // 自定义模型ID，默认为文件ID
                modelId: modelid
            });
        },
        addModel1() {
            
        },
        // 构造环状扫描效果
        showRingScan() {
            if (!isRingScanEffectAdded) {
                // 构造环状扫描效果配置项
                let ringScanEffectConfig = new Glodon.Bimface.Plugins.Animation.RingScanEffectConfig();
                // 配置Viewer对象、颜色、持续时间、位置、半径、衰减力度等参数
                ringScanEffectConfig.viewer = viewer3D;
                ringScanEffectConfig.color = new Glodon.Web.Graphics.Color(255, 0, 0, 1);
                ringScanEffectConfig.duration = 2000;
                ringScanEffectConfig.originPosition = {
                    x: 500000,
                    y: 100000,
                    z: 418000
                };
                ringScanEffectConfig.radius = 200000;
                ringScanEffectConfig.progressive = 5;
                // 构造环状扫描效果对象
                ringScanEffect = new Glodon.Bimface.Plugins.Animation.RingScanEffect(ringScanEffectConfig);
                ringScanEffect.show();
                viewer3D.render();
                this.setButtonText('btnShowRingScan', '清除');
            } else {
                // 清除环状扫描效果
                console.log(1);
                ringScanEffect.destroy();
                this.setButtonText('btnShowRingScan', '环状扫描');
            }
            isRingScanEffectAdded = !isRingScanEffectAdded;
        },
        setButtonText(btnId, text) {
            let dom = document.getElementById(btnId);
            if (dom != null && dom.nodeName == "BUTTON") {
                dom.innerText = text;
            }
        },
        getComponentProperty() {
            console.log(1);
            viewer3D.getModel().getComponentProperty("291468", function (objectdata) {
                console.log(2)
                alert(JSON.stringify(objectdata));
            });
        }
    },
    name: 'lighttest',
    created() {

        this.$axios({
            url: this.apiurl +
                "LightModel/LoadModels?FileId=100031085637"
        }).then((res) => {
            if (res.status == 200) {
                this.OSGBviewToken = res.data;
                this.fluseModel();

                this.$axios({
                    url: this.apiurl +
                        "LightModel/LoadModels?FileId="+modelid
                }).then((res) => {
                    if (res.status == 200) {
                        this.ModelviewToken = res.data;
                    }
                }, (err) => {
                });
                this.$axios({
                    url: this.apiurl +
                        "LightModel/LoadModels?FileId="+modelid1
                }).then((res) => {
                    if (res.status == 200) {
                        this.ModelviewToken1 = res.data;
                    }
                }, (err) => {
                });
            }
        }, (err) => {
        });

        // viewer3D.loadModel({
        //         // 待加载模型的浏览凭证
        //         viewToken: "60a1a691d82c47399c4df41be6e1d19c",
        //         // 自定义模型ID，默认为文件ID
        //         modelId: 100031085520

        //     });

    },
    mounted() {

        // 组件挂载后，设置默认选中第一项

    }

}

</script>